import { SelectField } from '../select-field';
import { FC } from 'react';
import map from 'lodash/map';
import { SelectFieldProps } from '../select-field/SelectField';
import { useLanguage } from '../../../core/hooks/useLanguage';
import { LanguageDto } from '../../../core/http';

export const LanguageField: FC<Omit<SelectFieldProps, 'items'>> = ({
  value,
  ...props
}) => {
  const { items } = useLanguage();
  const selectItems = map(items, (item: LanguageDto) => ({
    value: item.uuid,
    label: item.name
  }));

  return (
    <SelectField
      label="Language"
      value={value || ''}
      items={selectItems}
      {...props}
    />
  );
};
